import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { ResultItem } from "@/components/list/Schedule/types";
import { UpdateResultRequest } from "@/components/list/Schedule/types/api";
import { formatScheduleValue } from "@/lib/common";

export const useResultTextEditor = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [item, setItem] = useState<ResultItem>();
  const [target, setTarget] = useState("");

  const targetLabel = useMemo(() => {
    switch (target) {
      case "field_t1": // 人数
        return t("number_of_workers");
      default:
        return "";
    }
  }, [target, t]);

  const enter = (props: { item: ResultItem; target: string }) => {
    setItem(props.item);
    setTarget(props.target);
  };

  const exit = () => {
    setItem(null);
    setTarget(null);
  };

  const submit = (value?: string, e?: HTMLTextAreaElement) => {
    // バリデーション
    if (["field_t1"].includes(target) && value) {
      const num = Number(value);
      if (!(Number.isSafeInteger(num) && 0 <= num)) {
        dispatch(
          actions.app.showAlert(t("error"), [t("invalid_number_format", { field: targetLabel })], () =>
            dispatch(actions.app.hideAlert())
          )
        );
        e?.focus();
        return;
      }
    }

    // 更新
    const request: UpdateResultRequest = {
      input: {
        result_task_id: item.result_task_id,
        target,
        value: formatScheduleValue(target, value),
        update_date: item[`${target}_update_date`] ?? item.timestamp.update_date,
      },
      diff_number_of_workers: diffNumberOfWorkers(value),
    };
    dispatch(actions.schedule.updateResult(request));

    exit();
  };

  const diffNumberOfWorkers = (v?: string | number): number => {
    if (target !== "field_t1") return 0;
    const current = Number(item.field_t1 || 0);
    const newValue = isNaN(Number(v)) ? 0 : Number(v || 0);

    return newValue - current;
  };

  return { id: item?.result_task_id, target, enter, exit, submit };
};
